import React, { FC } from 'react';

import { PlatformBuy } from '@redux/reducers/profile/types';

import Box from '../atoms/Box/Box';
import { Row } from '../atoms/Grid';
import Text from '../atoms/Text/Text';

import AvailablePlatform from './AvailablePlatform';

type AvailablePlatformsProps = {
  title: string;
  platforms: PlatformBuy[];
};

const AvailablePlatforms: FC<AvailablePlatformsProps> = ({
  title,
  platforms,
}) => {
  return (
    <Box mt={1.5} mb={1.375}>
      <Box mb={0.875}>
        <Text color="cornflowerBlue" weight="bold" size={1.125}>
          {title}
        </Text>
      </Box>
      <Row gutter={0}>
        {platforms.map(platform => (
          <AvailablePlatform
            key={platform.name}
            name={platform.name}
            icon={platform.icon}
          />
        ))}
      </Row>
    </Box>
  );
};

export default AvailablePlatforms;
